import React, {useState} from 'react';

import styles from './DetailedOptionsHistoryItem.module.scss';
import {useNavigate} from "react-router-dom";
import {MAIN_ROUTES} from "../../../routing/main_routes";
import DeleteOrder from "../../DeleteOrder/DeleteOrder";

const DetailedOptionsHistoryItem = ({id}) => {
    const navigate = useNavigate();

    return (
        <ul className={styles.list}>
            <li
                className={styles.list_item}
                onClick={() => navigate(`${MAIN_ROUTES.HISTORY_ORDER_DETAILS}/${id}`)}
            >Переглянути деталі
            </li>
            {/*<li*/}
            {/*    className={styles.list_item}*/}
            {/*    onClick={() => navigate(`${MAIN_ROUTES.HISTORY_ORDER_DETAILS}/1`)}*/}
            {/*>Переглянути пропозиції*/}
            {/*</li>*/}
        </ul>
    );
};

export default DetailedOptionsHistoryItem;
